import { StyleSheet, Text, View } from 'react-native';
import ThermenImage from 'src/presentation/components/molecules/ThermenImage';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	image: string | null;
	title: string;
}

export default function WorkspaceRow({ image = null, title }: Props) {
	return (
		<View style={styles.row}>
			{image && <ThermenImage source={{ uri: image }} style={styles.environmentIcon} />}
			<Text style={styles.smallTextEnv}>{title}</Text>
		</View>
	);
}

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
	},
	smallTextEnv: {
		lineHeight: Dimens.lineHeight17,
		paddingLeft: Dimens.padding8,
		paddingBottom: Dimens.padding20,
		fontFamily: Fonts.barlow,
		fontSize: Dimens.fontSize15,
		flex: Dimens.flex1,
	},
	environmentIcon: {
		height: Dimens.size17,
		width: Dimens.size17,
	},
});
